/**
 * CardHolder — dumb-компонент для отображения карт в Russian Poker.
 *
 * Принимает только CardHolderViewModel (создается через mapper).
 * Вся доменная логика — в mapper, здесь только рендер.
 */
import CardHolderView from './CardHolder.view'

export default CardHolderView
export {
  mapBoxToCardHolderVM,
  mapDealerToCardHolderVM,
} from './cardHolder.mapper'
export type {
  BoxCardHolderDTO,
  CardHolderViewModel,
  DealerCardHolderDTO,
} from './CardHolder.types'
